import Vue from 'vue'
import store from '@/store/store.js'
export const error = state => state.error
export const isLoading = state => state.isLoading
export const items = state => state.items
export const view = state => state.view
export function addressTypeOptions () {
  return store.getters['configuration/addressTypeOptions'].map(entry => {
    return {
      value: entry.value,
      text: Vue.prototype.$lang.t(entry.text)
    }
  })
}
export const getAddressTypeText = state => id => {
  return Vue.prototype.$lang.t(store.getters['configuration/addressTypeOptions'].find(entry => entry.value === id).text)
}
